module.exports = __webpack_public_path__ + "img/chair.a19ee750.png";